export default {
  materialfloor:{
    cedar:{
      thumbnail: '/assets/materiallist/thumbnails/floor/floor_.Cedarpng.png',
      xml: '/assets/materiallist/材質データ/床板/杉/無垢　杉クリア.material',
    },
    oak:{
      thumbnail: '/assets/materiallist/thumbnails/floor/floor_.Oak3png.png',
      xml: '/assets/materiallist/材質データ/床板/オーク/無垢　オークピュアナチュラル.material',
    },
    teak:{
      thumbnail: '/assets/materiallist/thumbnails/floor/floor_.teak.png',
      xml: '/assets/materiallist/材質データ/床板/チーク/無垢　チークピュアナチュラル.material',
    },
    mahogany:{
      thumbnail: '/assets/materiallist/thumbnails/floor/floor_mahogany.png',
      xml: '/assets/materiallist/材質データ/床板/マホガニー/無垢　マホガニーアンティーク.material',
    },
    walnut:{
      thumbnail: '/assets/materiallist/thumbnails/floor/floor_walnut.png',
      xml: '/assets/materiallist/材質データ/床板/ウォルナット/突板　ウォルナットナチュラル.material',
    },
  },
  materialsofa:{
    SE202:{
      thumbnail: '/assets/materiallist/thumbnails/sofa/sofa_SE202.png',
      xml: '/assets/materiallist/材質データ/ソファ/org/se-202.material',
    },
    SE203:{
      thumbnail: '/assets/materiallist/thumbnails/sofa/sofa_SE203.png',
      xml: '/assets/materiallist/材質データ/ソファ/org/se-203.material',
    },
    SE206:{
      thumbnail: '/assets/materiallist/thumbnails/sofa/sofa_SE206.png',
      xml: '/assets/materiallist/材質データ/ソファ/org/se-206.material',
    },
    SE209:{
      thumbnail: '/assets/materiallist/thumbnails/sofa/sofa_SE209.png',
      xml: '/assets/materiallist/材質データ/ソファ/org/se-209.material',
    },
  },
  materialinnerwall:{
    SD0860:{
      thumbnail: '/assets/materiallist/thumbnails/innerwall/wall_SD0860.png',
      xml: '/assets/materiallist/材質データ/内壁/org/ｓｄ－０８６０.material',
    },
    SG5220:{
      thumbnail: '/assets/materiallist/thumbnails/innerwall/wall_SG5220.png',
      xml: '/assets/materiallist/材質データ/内壁/org/ｓｇ－５２２０.material',
    },
    SR1510:{
      thumbnail: '/assets/materiallist/thumbnails/innerwall/wall_SR1510.png',
      xml: '/assets/materiallist/材質データ/内壁/org/ｓｒ－１５１０.material',
    },
    SR29044B:{
      thumbnail: '/assets/materiallist/thumbnails/innerwall/wall_SR29044B.png',
      xml: '/assets/materiallist/材質データ/内壁/org/ｓｒ２９０４４ｂ.material',
    },
    SR29054B:{
      thumbnail: '/assets/materiallist/thumbnails/innerwall/wall_SR29054B.png',
      xml: '/assets/materiallist/材質データ/内壁/org/ｓｒ２９０５４ｂ.material',
    },
  },
  materialouterwall:{
    suls01:{
      thumbnail: '/assets/materiallist/thumbnails/outerwall/outerwall_suls01.png',
      xml: '/assets/materiallist/材質データ/外壁/org/ラフ仕上げ　ｓｕｌｓ－０１.material',
    },
    suls07:{
      thumbnail: '/assets/materiallist/thumbnails/outerwall/outerwall_suls07.png',
      xml: '/assets/materiallist/材質データ/外壁/org/刷毛引き　ｓｕｌｓ－０７.material',
    },
    suls08:{
      thumbnail: '/assets/materiallist/thumbnails/outerwall/outerwall_suls08.png',
      xml: '/assets/materiallist/材質データ/外壁/org/ヘアーライン　ｓｕｌｓ－０８.material',
    },
    suls11:{
      thumbnail: '/assets/materiallist/thumbnails/outerwall/outerwall_suls11.png',
      xml: '/assets/materiallist/材質データ/外壁/org/トラバーチン　ｓｕｌｓ－１１.material',
    },
    suls12:{
      thumbnail: '/assets/materiallist/thumbnails/outerwall/outerwall_suls12.png',
      xml: '/assets/materiallist/材質データ/外壁/org/シラスｌ　ｓｕｌｓ－１２.material',
    },

  },
  materialkitchen:{
    gold:{
      thumbnail: '/assets/materiallist/thumbnails/kitchen/kichin_エイジングゴールド.png',
      xml: '/assets/materiallist/材質データ/キッチン/org/leyk／heyk　【扉】エイジングゴールド.material',
    },
    kurenai:{
      thumbnail: '/assets/materiallist/thumbnails/kitchen/kichin_こきくれない.png',
      xml: '/assets/materiallist/材質データ/キッチン/org/leyk／heyk　【扉】こきくれない.material',
    },
    white:{
      thumbnail: '/assets/materiallist/thumbnails/kitchen/kichin_ベーシックホワイト.png',
      xml: '/assets/materiallist/材質データ/キッチン/org/leyk　【扉】ベーシックホワイト.material',
    },
    cheek:{
      thumbnail: '/assets/materiallist/thumbnails/kitchen/kichin_ミディアムチーク.png',
      xml: '/assets/materiallist/材質データ/キッチン/org/leyk／heyk　【扉】ミディアムチーク.material',
    },
    rurikon:{
      thumbnail: '/assets/materiallist/thumbnails/kitchen/kichin_るりこん.png',
      xml: '/assets/materiallist/材質データ/キッチン/org/leyk　【扉】るりこん.material',
    },

    
  }
}
